// RolesList.jsx
import React, { useState, useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSort,
  faSortUp,
  faSortDown,
  faEllipsisVertical,
  faInfoCircle,
  faCopy
} from '@fortawesome/free-solid-svg-icons';
import './style.css';

const RolesList = () => {
  const [activeTab, setActiveTab] = useState('system');
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [activeMenuIndex, setActiveMenuIndex] = useState(null);
  const [copiedItem, setCopiedItem] = useState(null);

  // Данные для справочника ролей
  const referenceData = {
    // Системные роли
    system: [
      {
        id: 1,
        title: 'Адміністратор системи',
        code: 'ADMIN_SYSTEM',
        description: 'Виконує роль з управлінння користувачами. Забезпечує контроль щодо критичних налаштувань щодо груп. Контролює работу модераторів системи',
        permissions: 'Повний доступ до всіх функцій системи, управління користувачами, налаштування системи',
        responsibilities: 'Контроль роботи модераторів, управління критичними налаштуваннями',
        accessLevel: 'Повний',
        status: 'Активний',
        note: 'Найвищий рівень доступу'
      },
      {
        id: 2,
        title: 'Модератор',
        code: 'MODERATOR',
        description: 'Забезпечує контроль формування груп по району. Підтверджує пільги. Контролює работу директорів садочку',
        permissions: 'Управління групами, підтвердження пільг, контроль роботи керівників',
        responsibilities: 'Формування груп по районах, верифікація документів на пільги',
        accessLevel: 'Високий',
        status: 'Активний',
        note: 'Регіональний рівень управління'
      }
    ],
    
    // Роли садика
    kindergarten: [
      {
        id: 1,
        title: 'Керівник садочку',
        code: 'DIRECTOR_KINDERGARTEN',
        description: 'Виконує всі необхідні дії щодо формування груп. Забезпечує оформлення дітей в садочок. Контролює работу садочку',
        permissions: 'Управління групами в садочку, оформлення дітей, звітність',
        responsibilities: 'Формування груп, контроль відвідування, комунікація з батьками',
        accessLevel: 'Середній',
        status: 'Активний',
        note: 'Рівень окремого закладу'
      },
      {
        id: 2,
        title: 'Медична сестра садочку',
        code: 'NURSE_KINDERGARTEN',
        description: 'Забезпечує реєстрацію присутності. Контроль за табелем відвідування.',
        permissions: 'Ведення медичних записів, відмітка відвідування, звіти по здоров\'ю',
        responsibilities: 'Щоденний контроль стану здоров\'я дітей, ведення медичної документації',
        accessLevel: 'Обмежений',
        status: 'Активний',
        note: 'Спеціалізований медичний доступ'
      }
    ],
    
    // Технические роли
    technical: [
      {
        id: 1,
        title: 'Фахівець технічної підтримки',
        code: 'SUPPORT_SPECIALIST',
        description: 'Виконує роль з інформаційної підтримки користувачів.',
        permissions: 'Доступ до системи підтримки',
        responsibilities: 'Консультування користувачів, вирішення технічних проблем',
        accessLevel: 'Технічний',
        status: 'Активний',
        note: 'Не має доступу до особистих даних'
      }
    ]
  };

  // Колонки для разных вкладок
  const columnsConfig = {
    system: [
      { key: 'title', label: 'Назва ролі', sortable: true, width: '15%' },
      { key: 'code', label: 'Код', sortable: true, width: '10%' },
      { key: 'description', label: 'Опис', sortable: true, width: '20%' },
      { key: 'permissions', label: 'Права доступу', sortable: true, width: '15%' },
      { key: 'responsibilities', label: 'Обов\'язки', sortable: true, width: '15%' },
      { key: 'accessLevel', label: 'Рівень доступу', sortable: true, width: '10%' },
      { key: 'status', label: 'Статус', sortable: true, width: '8%' },
      { key: 'note', label: 'Примітка', sortable: true, width: '7%' },
      { key: 'actions', label: 'Дії', sortable: false, width: '5%' }
    ],
    kindergarten: [
      { key: 'title', label: 'Назва ролі', sortable: true, width: '15%' },
      { key: 'code', label: 'Код', sortable: true, width: '10%' },
      { key: 'description', label: 'Опис', sortable: true, width: '20%' },
      { key: 'permissions', label: 'Права доступу', sortable: true, width: '15%' },
      { key: 'responsibilities', label: 'Обов\'язки', sortable: true, width: '15%' },
      { key: 'accessLevel', label: 'Рівень доступу', sortable: true, width: '10%' },
      { key: 'status', label: 'Статус', sortable: true, width: '8%' },
      { key: 'note', label: 'Примітка', sortable: true, width: '7%' },
      { key: 'actions', label: 'Дії', sortable: false, width: '5%' }
    ],
    technical: [
      { key: 'title', label: 'Назва ролі', sortable: true, width: '15%' },
      { key: 'code', label: 'Код', sortable: true, width: '10%' },
      { key: 'description', label: 'Опис', sortable: true, width: '20%' },
      { key: 'permissions', label: 'Права доступу', sortable: true, width: '15%' },
      { key: 'responsibilities', label: 'Обов\'язки', sortable: true, width: '15%' },
      { key: 'accessLevel', label: 'Рівень доступу', sortable: true, width: '10%' },
      { key: 'status', label: 'Статус', sortable: true, width: '8%' },
      { key: 'note', label: 'Примітка', sortable: true, width: '7%' },
      { key: 'actions', label: 'Дії', sortable: false, width: '5%' }
    ]
  };

  const columns = columnsConfig[activeTab];

  // Функция сортировки
  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  // Сортированные данные
  const sortedData = useMemo(() => {
    const data = referenceData[activeTab];
    if (!sortConfig.key) return data;
    
    return [...data].sort((a, b) => {
      const aValue = a[sortConfig.key] || '';
      const bValue = b[sortConfig.key] || '';

      if (aValue < bValue) {
        return sortConfig.direction === 'asc' ? -1 : 1;
      }
      if (aValue > bValue) {
        return sortConfig.direction === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }, [referenceData, activeTab, sortConfig]);

  const getSortIcon = (columnKey) => {
    if (columnKey !== sortConfig.key) return faSort;
    return sortConfig.direction === 'asc' ? faSortUp : faSortDown;
  };

  const handleMenuToggle = (index) => {
    setActiveMenuIndex(activeMenuIndex === index ? null : index);
  };

  const handleMenuClose = () => {
    setActiveMenuIndex(null);
  };

  const handleCopyToClipboard = async (text, item) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedItem(item.id);
      setTimeout(() => setCopiedItem(null), 2000);
    } catch (err) {
      console.error('Помилка копіювання: ', err);
    }
  };

  const handleActionSelect = (actionId, item) => {
    if (actionId === 'view') {
      // Показать детальную информацию
      let message = '';
      if (activeTab === 'system' || activeTab === 'kindergarten' || activeTab === 'technical') {
        message = `Роль: ${item.title}\nКод: ${item.code}\nОпис: ${item.description}\nПрава доступу: ${item.permissions}\nОбов'язки: ${item.responsibilities}\nРівень доступу: ${item.accessLevel}\nСтатус: ${item.status}\nПримітка: ${item.note}`;
      }
      alert(message);
    } else if (actionId === 'copy') {
      // Копировать код для использования в формах
      handleCopyToClipboard(item.code, item);
    }
    setActiveMenuIndex(null);
  };

  const ActionsMenu = ({ onActionSelect, onClose, item }) => {
    const actions = [
      {
        id: 'view',
        label: 'Переглянути деталі',
        icon: faInfoCircle
      },
      {
        id: 'copy',
        label: 'Копіювати код',
        icon: faCopy
      }
    ];

    return (
      <div className="actions-dropdown">
        {actions.map((action) => (
          <button
            key={action.id}
            className="dropdown-item d-flex align-items-center gap-2 p-2"
            onClick={() => onActionSelect(action.id, item)}
            style={{
              border: 'none',
              backgroundColor: 'transparent',
              width: '100%',
              textAlign: 'left',
              fontSize: '14px',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
          >
            <FontAwesomeIcon icon={action.icon} style={{ width: '16px', color: '#6c757d' }} />
            <span style={{ color: '#212529' }}>{action.label}</span>
          </button>
        ))}
        
        <div style={{ borderTop: '1px solid #dee2e6', padding: '8px' }}>
          <button
            className="btn btn-sm btn-outline-secondary w-100"
            onClick={onClose}
            style={{ fontSize: '12px' }}
          >
            Скасувати
          </button>
        </div>
      </div>
    );
  };

  return (
    <main className="queuetable-main-content queuetable-page">
      <div className="container-fluid">
        <div className="queuetable-content-wrapper">
          {/* Панель табов */}
          <div className="queuetable-year-bar d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center gap-3 flex-wrap">
              <span className="queuetable-label text-white-50">Довідник ролей системи</span>
              <ul className="queuetable-year-tabs nav nav-tabs">
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === 'system' ? 'active' : ''}`}
                    onClick={() => {
                      setActiveTab('system');
                      setSortConfig({ key: null, direction: 'asc' });
                    }}
                  >
                    Системні ролі
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === 'kindergarten' ? 'active' : ''}`}
                    onClick={() => {
                      setActiveTab('kindergarten');
                      setSortConfig({ key: null, direction: 'asc' });
                    }}
                  >
                    Ролі садочку
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === 'technical' ? 'active' : ''}`}
                    onClick={() => {
                      setActiveTab('technical');
                      setSortConfig({ key: null, direction: 'asc' });
                    }}
                  >
                    Технічні ролі
                  </button>
                </li>
              </ul>
            </div>
          </div>

          {/* Уведомление о копировании */}
          {copiedItem && (
            <div className="alert alert-success alert-dismissible fade show" role="alert">
              <FontAwesomeIcon icon={faCopy} className="me-2" />
              Код ролі успішно скопійовано в буфер обміну!
            </div>
          )}

          {/* Таблица */}
          <div className="card queuetable-table-card">
            <div className="card-body p-0">
              <div className="table-responsive">
                <table className="table queuetable-table align-middle mb-0">
                  <thead>
                    <tr>
                      {columns.map((column) => (
                        <th 
                          key={column.key}
                          style={{ width: column.width }}
                          onClick={() => column.sortable && handleSort(column.key)}
                        >
                          <div className="d-flex align-items-center">
                            {column.label}
                            {column.sortable && (
                              <FontAwesomeIcon 
                                icon={getSortIcon(column.key)} 
                                className="ms-1" 
                                style={{ fontSize: '12px' }}
                              />
                            )}
                          </div>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {sortedData.map((item, index) => (
                      <tr key={item.id}>
                        {/* Динамическое отображение колонок в зависимости от вкладки */}
                        {columns.map((column) => {
                          if (column.key === 'actions') {
                            return (
                              <td key="actions" className="queuetable-actions text-end">
                                <div className="actions-menu-container" style={{ position: 'relative', display: 'inline-block' }}>
                                  <button
                                    className="btn btn-sm btn-link text-decoration-none p-0"
                                    onClick={() => handleMenuToggle(index)}
                                    style={{ color: '#0d6efd' }}
                                  >
                                    <FontAwesomeIcon icon={faEllipsisVertical} />
                                  </button>
                                  
                                  {activeMenuIndex === index && (
                                    <ActionsMenu 
                                      onActionSelect={handleActionSelect}
                                      onClose={handleMenuClose}
                                      item={item}
                                    />
                                  )}
                                </div>
                              </td>
                            );
                          }
                          
                          return (
                            <td key={column.key}>
                              {item[column.key]}
                            </td>
                          );
                        })}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Пагинация */}
              <div className="d-flex align-items-center mt-4 queuetable-pagination-wrapper">
                <div className="queuetable-pagination-info">
                  Всього {sortedData.length} записів
                </div>
              </div>
            </div>
          </div>

          {/* Информационное сообщение */}
          <div className="alert alert-info mt-3" role="alert">
            <FontAwesomeIcon icon={faInfoCircle} className="me-2" />
            <strong>Довідник ролей системи</strong> - цей довідник містить опис усіх ролей, доступних у системі. 
            Ви можете використовувати коди ролей для призначення прав користувачам.
          </div>
        </div>
      </div>
    </main>
  );
};

export default RolesList;